export default {
  getHead: () => {
    return [{name: '사업장명'}, {name: '사업명'}, {name: '작업의 종류'}, {name: '신청부서'}, {name: '작업중지 일자'}, {name: '작성자'}, {name: '작성일'}, {name: '첨부파일'}]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).inputA_1
        case 1: return func.getContent(value).inputB_4
        case 2: return func.getContent(value).inputB_5
        case 3: return func.getCompanyName(func.getContent(value).inputB_1)
        case 4: return func.getContent(value).inputB_6
        case 5: return value.user ? value.user.name : value.author.name
        case 6: return func.getCreatedDate(value.created_at) // 작성일
        case 7: return { type: 'file', files: func.getContent(value).fileList}
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.inputB_6) {
      nav.dateTarget = 'content$body.inputB_6'
      nav.dateBegin = 'nav.value.inputB_6.sDate'
      nav.dateEnd = 'nav.value.inputB_6.eDate'
    }
    return {inputB_6: nav.value.inputB_6}
  },
  getSearchKeyword: (nav) => {
    return []
  },
}
